export class AnalyseCyano {
    FacteurConcentration: number
    VolumeConcentrat: number

    static mapFromJSON(json): any {
        const ac = new AnalyseCyano();

        ac.FacteurConcentration = json.facteurConcentration;
        ac.VolumeConcentrat = json.volumeConcentrat;

        return ac
    }
}